// Help Center topics. Array order is the Help Center landing-page display order.

import { GETTING_STARTED_TOPIC } from 'src/services/consts/faq/topics/getting-started.const'
import { CONSENT_BANNERS_TOPIC } from 'src/services/consts/faq/topics/consent-banners.const'
import { COOKIE_SCANNING_TOPIC } from 'src/services/consts/faq/topics/cookie-scanning.const'
import { DEVELOPERS_TOPIC } from 'src/services/consts/faq/topics/developers.const'
import { PRIVACY_BASICS_TOPIC } from 'src/services/consts/faq/topics/privacy-basics.const'
import { ACCOUNT_AND_TEAM_TOPIC } from 'src/services/consts/faq/topics/account-and-team.const'

/** @type {import('src/services/helpers/faq/content.helper').FaqTopic[]} */
export const FAQ_TOPICS = [
  GETTING_STARTED_TOPIC,
  CONSENT_BANNERS_TOPIC,
  COOKIE_SCANNING_TOPIC,
  DEVELOPERS_TOPIC,
  PRIVACY_BASICS_TOPIC,
  ACCOUNT_AND_TEAM_TOPIC,
]
